import { CorreoDetalleBpm } from './CorreoDetalleBpm';
import { GetDateTime } from '../general/variables';

export class CorreoBpm {
    cbpmmailProactiname = 'Registrar Documento';
    cbpmmailProappacronym = 'SADWEB';
    cbpmmailProappname = 'SADWEB';
    cbpmmailProinstanceid: string;
    cbpmmailProinstname = 'Gestión de Canales';
    cbpmmailProinsttaskpri = 'Normal';
    cbpmmailTaskid: string;
    cbpmmailUserfullname = 'SADWEB';
    cbpmmailUserid: string;
    dbpmmailFchregistro: string;
    dbpmmailProinstduedate: string;
    dbpmmailProinsttaskduedate: string;
    dbpmmailTaskatriskdate: string;
    listaMailDetalle: CorreoDetalleBpm[];
    nbpmmailId: string;

    strDbpmmailFchregistro: string = GetDateTime(0, 0);
    strDbpmmailProinstduedate: string = GetDateTime(0, 0);
    strDbpmmailProinsttaskduedate: string = GetDateTime(0, 0);
    strDbpmmailTaskatriskdate: string = GetDateTime(0, 0);


}
